<template>
  <div>
    <div style="background-color:#e1c468">
      <v-container
        v-if="!$store.state.mobile"
        class="py-0"
      >
        <v-row
          no-gutters
          align="center"
        >
          <v-col
            cols="auto"
            class="font-light py-2"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              أهلا بك في سدة الخليج للتجارة
            </template>
            <template v-else>
              Welcome to Saddat Alkhaleej Trading!!!
            </template>
          </v-col>
          <v-spacer />
          <v-col
            cols="auto"
            class="d-flex align-stretch"
          >
            <template v-if="$store.state.user">
              <div class="py-2">
                <template v-if="$store.getters.languageGetter === '1'">
                  أهلا بك
                </template>
                <template v-else>
                  Welcome
                </template>,
              </div>
              <div
                class="mx-2 py-2 d-block cursor-pointer position-relative"
                @mouseover="menuToggle = true;"
                @mouseleave="menuToggle = false"
              >
                <router-link :to="{name: 'UserDashboard'}">
                  {{ $store.state.user.email }}
                </router-link>
                <v-icon
                  size="18px"
                  color="primary"
                  class="flip-reverse"
                  :class="menuToggle ? 'reverse' : ''"
                >
                  mdi-menu-down
                </v-icon>
                <v-slide-y-reverse-transition>
                  <v-card
                    v-if="menuToggle"
                    class="menu-toggle"
                    :style="$vuetify.rtl ? 'left: 0' : 'right: 0;'"
                  >
                    <v-list>
                      <v-list-item
                        :to="{name: 'UserOrderList'}"
                        exact
                      >
                        <v-list-item-content>
                          <v-list-item-title class="text-h5 font-medium">
                            <template v-if="$store.getters.languageGetter === '1'">
                              طلباتي
                            </template>
                            <template v-else>
                              My Orders
                            </template>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        :to="{name: 'UserFavoriteList'}"
                        exact
                      >
                        <v-list-item-content>
                          <v-list-item-title class="text-h5 font-medium">
                            <template v-if="$store.getters.languageGetter === '1'">
                              مفضلتي
                            </template>
                            <template v-else>
                              My Favorites
                            </template>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        :to="{name: 'UserAccountSettings'}"
                        exact
                      >
                        <v-list-item-content>
                          <v-list-item-title class="text-h5 font-medium">
                            <template v-if="$store.getters.languageGetter === '1'">
                              إعدادات الحساب
                            </template>
                            <template v-else>
                              Account Setting
                            </template>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-divider />
                    <v-card
                      outlined
                      class="ma-3 pa-2 font-medium text-h6"
                      @click="logOut"
                    >
                      <template v-if="$store.getters.languageGetter === '1'">
                        تسجيل الخروج من الحساب
                      </template>
                      <template v-else>
                        Sign Out
                      </template>
                    </v-card>
                  </v-card>
                </v-slide-y-reverse-transition>
              </div>
            </template>
            <template v-else>
              <div
                class="mx-2 py-2 cursor-pointer"
                @click="$emit('update:login')"
              >
                <v-icon size="18px">
                  mdi-account-outline
                </v-icon>
                <template v-if="$store.getters.languageGetter === '1'">
                  تسجيل دخول
                </template>
                <template v-else>
                  Sign In
                </template>
              </div><span
                class="py-2"
              > <template v-if="$store.getters.languageGetter === '1'">
                  أو
                </template>
                <template v-else>
                  or
                </template></span>
              <router-link
                to="/register"
                class="mx-2 py-2"
              >
                <v-icon size="14px">
                  mdi-pencil-outline
                </v-icon>
                <template v-if="$store.getters.languageGetter === '1'">
                  تسجيل
                </template>
                <template v-else>
                  Register
                </template>
              </router-link>
              <v-divider
                vertical
                class="mx-2 align-self-center"
                style="border-color:#959595;min-height:35%"
              />
              <router-link
                :to="{name: 'UserOrderList'}"
                class="py-2"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  طلباتي
                </template>
                <template v-else>
                  My Orders
                </template>
              </router-link>
            </template>
            <v-divider
              vertical
              class="mx-2 align-self-center"
              style="border-color:#959595;min-height:35%"
            />
            <div
              class="position-relative d-inline-block"
              @mouseover="helpTrigger = true;$forceUpdate()"
              @mouseleave="helpTrigger = false;$forceUpdate()"
            >
              <router-link
                to="/"
                class="py-2 d-inline-block"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  مركز المساعدة
                </template>
                <template v-else>
                  Help center
                </template>
                <v-icon size="18px">
                  mdi-chevron-down
                </v-icon>
              </router-link>
              <v-slide-y-reverse-transition>
                <v-card
                  v-if="helpTrigger"
                  elevation="1"
                  tile
                  class="help-popup"
                  :style="$vuetify.rtl ? 'left: 0;right: -100px;' : 'right: 0;left: -100px;'"
                >
                  <v-list dense>
                    <v-list-item-group>
                      <v-list-item
                        v-for="item in helpCenter"
                        :key="item.id"
                        :to="{name: 'InformationContent', params: {id: item.id, title: $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn}}"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-slide-y-reverse-transition>
            </div>
          </v-col>
          <v-col cols="auto">
            <v-menu
              offset-y
              open-on-hover
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  rounded
                  color="#111f5e"
                  elevation="0"
                  class="d-flex align-center my-2 ms-3"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ $store.getters.languageGetter === '1' ? 'اللغة' : 'Language' }}
                  <v-spacer class="mx-2" />
                  <v-icon
                    small
                  >
                    mdi-chevron-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, i) in language"
                  :key="i"
                  class="pe-1"
                  @click="setLanguage(item)"
                >
                  <v-list-item-title>{{ $store.getters.languageGetter === '1' ? item.text : item.textEn }}</v-list-item-title>
                  <v-list-item-action v-if="item.value === $store.getters.languageGetter">
                    <v-icon small>
                      mdi-check
                    </v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-divider v-if="!$store.state.mobile" />
    <div style="background-color:#111f5e">
      <v-container
        :class="$store.state.mobile ? 'py-0' : ''"
      >
        <v-row align="center">
          <!-- 手机端弹出导航 -->
          <v-col
            v-if="$store.state.mobile"
            cols="auto"
            class="pe-0"
            @click="showPopup = !showPopup"
          >
            <v-icon color="white">
              mdi-menu
            </v-icon>
          </v-col>
          <v-col cols="auto">
            <router-link to="/">
              <v-img
                :src="this.$store.state.webConfig.logo"
                :width="$store.state.mobile ? 100 : 177"
                :height="$store.state.mobile ? 36 : 64"
              />
            </router-link>
          </v-col>
          <v-spacer />
          <v-col
            v-if="!$store.state.mobile"
            cols="8"
            md="6"
          >
            <v-text-field
              v-model="search"
              name="search"
              outlined
              rounded
              clearable
              dense
              hide-details
              class="custom-form mb-2"
              placeholder="Please enter keywords"
              @change="searchProducts"
            >
              <template v-slot:prepend-inner>
                <div
                  v-if="searchedImg"
                  class="position-relative d-inline-flex align-stretch me-2"
                  style="height:26px"
                >
                  <v-img
                    aspect-ratio="1"
                    contain
                    :src="searchedImg"
                    width="26px"
                    height="26px"
                  />
                  <div
                    class="grey lighten-3 d-flex align-center px-1"
                    style="cursor: pointer"
                    @click="searchedImg = ''"
                  >
                    <v-icon small>
                      mdi-close
                    </v-icon>
                  </div>
                </div>
              </template>
              <template v-slot:append>
                <img-search @update:img-searched="showSearchedImg" />
                <v-icon
                  color="#111f5e"
                  class="cursor-pointer"
                  @click="searchProducts"
                >
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
            <div class="line-break">
              <span class="white--text me-2">
                <template v-if="$store.getters.languageGetter === '1'">
                  البحث الساخن:
                </template>
                <template v-else>
                  Hot search:
                </template>
              </span>
              <router-link
                v-for="item in hotSearchPublished"
                :key="item.id"
                :to="{name: 'GoodsList', query: {searchStr: item.dnames, p: 1}}"
                class="me-2 white--text"
              >
                {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
              </router-link>
            </div>
          </v-col>
          <v-col
            cols="auto"
            class="text-h4 d-flex align-center position-relative"
            @mouseover="cartTriggerAction(true)"
            @mouseleave="cartTriggerAction(false)"
          >
            <v-icon
              v-if="$store.state.mobile"
              size="30px"
              color="white"
              class="me-4 cursor-pointer"
              @click="showSearch = true"
            >
              mdi-magnify
            </v-icon>
            <router-link
              class="cursor-pointer"
              :to="{name: 'CartList'}"
            >
              <v-badge
                :value="$store.state.mobile && cartList.data.length"
                color="#f51414"
                overlap
                :content="cartList.data.length"
              >
                <v-icon
                  color="white"
                  size="30px"
                >
                  mdi-cart-outline
                </v-icon>
              </v-badge>
              <span
                v-if="!$store.state.mobile"
                class="mx-2 font-medium white--text"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  عربة التسوق
                </template>
                <template v-else>
                  Cart
                </template>
                {{ cartList.data.length }}</span>
            </router-link>
            <v-slide-y-reverse-transition>
              <v-card
                v-if="cartTrigger"
                class="cart-popup"
                tile
                max-width="350"
                :style="$vuetify.rtl ? 'left: 0;' : 'right: 0;'"
              >
                <div
                  v-if="cartList.status && cartList.data.length"
                >
                  <template v-for="(item, i) in cartList.data.slice(0,5)">
                    <v-list-item
                      :key="item.id"
                      two-line
                    >
                      <v-list-item-avatar tile>
                        <router-link :to="{name: 'GoodsDetail', params: {id: item.goodId}}">
                          <v-img
                            :src="item.specImage ? item.specImage + '?x-oss-process=image/resize,m_mfit,w_100,h_100' : item.image + '?x-oss-process=image/resize,m_mfit,w_100,h_100'"
                            width="60"
                            height="60"
                            contain
                            class="grey lighten-5"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey"
                                />
                              </v-row>
                            </template>
                          </v-img>
                        </router-link>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          <router-link :to="{name: 'GoodsDetail', params: {id: item.goodId}}">
                            {{ $store.getters.languageGetter === '1' ? item.goodName : item.goodNameEn }}
                          </router-link>
                        </v-list-item-title>
                        <v-list-item-subtitle class="d-flex">
                          {{ $store.getters.languageGetter === '1' ? item.goodDetailName : item.goodDetailNameEn }}
                          <span class="black--text ms-auto">x{{ item.goodNumber }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider
                      :key="i"
                      class="mx-2"
                    />
                  </template>
                  <v-list-item>
                    <v-list-item-subtitle class="d-flex align-center justify-center">
                      <span class="text-h5 black--text font-medium me-4">{{ $store.getters.countryGetter.currency }}{{ cartAmount.toFixed(2) }}</span>
                      <span class="font-medium black--text text-h5 me-1">{{ cartList.data.length }}</span>  {{ $store.getters.languageGetter === '1' ? 'نوع المنتج' : 'Item(s)' }}
                    </v-list-item-subtitle>
                  </v-list-item>
                </div>
                <v-card-text
                  v-else
                  class="body-1 text-center pa-10"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    سلة التسوق الخاصة بك فارغة.
                  </template>
                  <template v-else>
                    Your shopping cart is empty.
                  </template>
                </v-card-text>
                <v-divider />
                <v-card-actions v-if="cartList.status && cartList.data.length">
                  <v-btn
                    color="#f51414"
                    depressed
                    block
                    dark
                    tile
                    :to="{name: 'CartList'}"
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      عرض المزيد
                    </template>
                    <template v-else>
                      View More
                    </template>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-slide-y-reverse-transition>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-divider />
    <!-- 桌面导航 -->
    <navbar-mobile
      v-if="$store.state.mobile"
      :show="showPopup"
      @update:close="showPopup = false;$emit('update:hide-pop')"
    />
    <navbar-desktop v-if="!$store.state.mobile && $route.meta.requiredNavbar" />
    <v-dialog v-model="showSearch">
      <v-text-field
        v-model="search"
        name="search"
        outlined
        rounded
        clearable
        dense
        hide-details
        class="custom-form"
        placeholder="Please enter keywords"
        @change="searchProducts"
      >
        <template v-slot:append>
          <img-search @update:img-searched="showSearchedImg" />
          <v-icon
            color="warning"
            class="cursor-pointer"
            @click="searchProducts"
          >
            mdi-magnify
          </v-icon>
        </template>
      </v-text-field>
    </v-dialog>
  </div>
</template>

<script>
import NavbarDesktop from '@/layout/NavbarDesktop.vue';
import NavbarMobile from '@/layout/NavbarMobile.vue';
import ImgSearch from '@/components/ImgSearch.vue';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'Header',
  components: {
    NavbarDesktop,
    NavbarMobile,
    ImgSearch,
  },
  props: {
    showPop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuToggle: false,
      cartTrigger: false,
      search: '',
      helpTrigger: false,
      showPopup: false,
      showSearch: false,
      searchedImg: '',
      language: [
        {
          text: 'عربي',
          textEn: 'Arabic',
          value: '1',
        },
        {
          text: 'الإنجليزية',
          textEn: 'English',
          value: '2',
        },
      ],
    };
  },
  computed: {
    ...mapState('cart', ['cartList']),
    ...mapGetters(['hotSearchPublished']),
    ...mapGetters('information', ['helpCenter']),
    cartAmount() {
      return this.cartList.data.reduce((acc, item) => acc + parseFloat(item.buNumber) * parseFloat((this.priceRate(item) * this.$store.state.user.rebate) / 100), 0);
    },
  },
  watch: {
    showPop(newValue) {
      if (newValue) {
        this.showPopup = true;
      }
    },
  },
  created() {
    this.loadComponentsData();
  },
  methods: {
    ...mapActions(['getHotSearchAsync', 'logOutAsync']),
    ...mapActions('cart', ['getCartListAsync']),
    ...mapActions('information', ['getInfoListAsync']),
    setLanguage(item) {
      if (item.value === '1') {
        this.$vuetify.rtl = true;
        document.title = this.$store.state.webConfig.companyName;
      } else {
        this.$vuetify.rtl = false;
        document.title = this.$store.state.webConfig.companyNameEn;
      }
      this.$store.commit('SET_LANGUAGE', item);
    },
    loadComponentsData() {
      const promises = [this.getHotSearchAsync(), this.getCartListAsync(), this.getInfoListAsync()];
      Promise.all(promises);
    },
    searchProducts() {
      if (this.search) {
        this.showSearch = false;
        this.$store.commit('goods/RESET_GOODS_LIST');
        const query = {
          searchStr: this.search,
          p: 1,
        };
        this.search = '';
        if (this.$route.query.categoryId) {
          query.categoryId = this.$route.query.categoryId;
          query.categoryName = this.$route.query.categoryName;
        }
        if (this.$route.name === 'GoodsList') {
          this.$router.replace({
            name: 'GoodsList',
            query,
          });
        } else {
          this.$router.push({
            name: 'GoodsList',
            query,
          });
        }
      }
    },
    cartTriggerAction(v) {
      if (!this.$store.getters.countryGetter) return;
      if (!this.$store.state.mobile) {
        this.cartTrigger = v;
      }
    },
    showSearchedImg(url) {
      this.searchedImg = url;
    },
    logOut() {
      this.$store.commit('SET_MINI_LOADING');
      this.logOutAsync().finally(() => {
        this.$store.commit('SET_MINI_LOADING');
      });
    },
    priceRate(item) {
      return (+item.countryPrice[this.$store.getters.countryGetter.id] * +this.$store.getters.countryGetter.rate);
    },
  },
};
</script>

<style lang="scss" scoped>
.help-popup {
  position: absolute;
  z-index: 10;
  top: 100%;
  max-width: initial;
}

.font-size-large .v-list-item__title {
  font-size: 16px;
}

.menu-toggle {
  position: absolute;
  z-index: 10;
  top: 100%;
  min-width: 120px;
  max-width: initial;
}

.cart-popup {
  position: absolute;
  z-index: 10;
  top: 100%;
  max-width: initial;
  min-width: 300px;
}
</style>
